"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var layout_service_1 = require("./layout-service");

var graphql_request_client_1 = require("../graphql-request-client");

var debug_1 = __importDefault(require("../debug"));

var GraphQLLayoutService =
/** @class */
function (_super) {
  __extends(GraphQLLayoutService, _super);
  /**
   * Fetch layout data using the Sitecore GraphQL endpoint.
   * @param {GraphQLLayoutServiceConfig} serviceConfig
   */


  function GraphQLLayoutService(serviceConfig) {
    var _this = _super.call(this) || this;

    _this.serviceConfig = serviceConfig;
    _this.graphQLClient = _this.getGraphQLClient();
    return _this;
  }
  /**
   * Fetch layout data for an item.
   * @param {string} itemPath
   * @param {string} [language]
   * @returns {Promise<LayoutServiceData>} layout service data
   */


  GraphQLLayoutService.prototype.fetchLayoutData = function (itemPath, language) {
    var _a, _b;

    return __awaiter(this, void 0, void 0, function () {
      var query, data;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            query = this.getLayoutQuery(itemPath, language);
            debug_1.default.layout('fetching layout data for %s %s %s', itemPath, language, this.serviceConfig.siteName);
            return [4
            /*yield*/
            , this.graphQLClient.request(query)];

          case 1:
            data = _c.sent(); // If `rendered` is empty -> not found

            return [2
            /*return*/
            , ((_b = (_a = data) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.item.rendered) || {
              sitecore: {
                context: {
                  pageEditing: false,
                  language: language
                },
                route: null
              }
            }];
        }
      });
    });
  };
  /**
   * Gets a GraphQL client that can make requests to the API. Uses graphql-request as the default
   * library for fetching graphql data (@see GraphQLRequestClient). Override this method if you
   * want to use something else.
   * @returns {GraphQLClient} implementation
   */


  GraphQLLayoutService.prototype.getGraphQLClient = function () {
    return new graphql_request_client_1.GraphQLRequestClient(this.serviceConfig.endpoint, {
      apiKey: this.serviceConfig.apiKey,
      debugger: debug_1.default.layout
    });
  };
  /**
   * Returns GraphQL Layout query
   * @param {string} itemPath page route
   * @param {string} [language] language
   */


  GraphQLLayoutService.prototype.getLayoutQuery = function (itemPath, language) {
    var languageVariable = language ? ", language:\"" + language + "\"" : '';
    var layoutQuery = this.serviceConfig.formatLayoutQuery ? this.serviceConfig.formatLayoutQuery(this.serviceConfig.siteName, itemPath, language) : "layout(site:\"" + this.serviceConfig.siteName + "\", routePath:\"" + itemPath + "\"" + languageVariable + ")";
    return "query {\n      " + layoutQuery + "{\n        item {\n          rendered\n        }\n      }\n    }";
  };

  return GraphQLLayoutService;
}(layout_service_1.LayoutServiceBase);

exports.GraphQLLayoutService = GraphQLLayoutService;